import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const FormatsVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "v1.0/Formats",
    $_dataMapsApiPath: "v1.0//",
    $_formats: [],
    $_dataMaps: [],
    $_currentFormat: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    allFormats: (state) => state.$_formats,
    currentFormat: (state) => state.$_currentFormat,
    allDataMaps: (state) => state.$_dataMaps,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initFormat({ commit }) {
      var format = {
        id: 0,
        formatTypeId: 0,
        name: "",
        pageSize: "",
        pageOrientation: "",
        fileLocation: "",
        isUrl: false,
        isFile: false,
        isTemplate: false,
        isActive: false
      };

      commit("SET_FORMAT", format);
    },
    clearFormats({ commit }) {
      commit("SET_FORMATS", []);
    },
    setFormat({ commit }, format) {
      commit("SET_FORMAT", format);
    },
    clearDataMaps({ commit }) {
      commit("SET_DATAMAPS", []);
    },
    async getFormats({ commit, dispatch, state, rootGetters }) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_FORMATS", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getDataMaps({ commit, dispatch, state, rootGetters }) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_DATAMAPS", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getFormat({ commit, dispatch, state, rootGetters }, id) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_FORMAT", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async createFormat({ commit, dispatch, state, rootGetters }, format) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        format.id = 0;
        const response = await axios.post(actionLink, format, axiosConfig);
        format.id = response.data.id;
        commit("SET_FORMAT", format);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async updateFormat({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.put(actionLink, data.format, axiosConfig);
        data.format.id = response.data.id;

        commit("SET_FORMAT", data.format);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async deleteFormat({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.id;
      var axiosConfig = rootGetters.axiosConfig;
      var $_axiosConfig = JSON.parse(JSON.stringify(axiosConfig));
      $_axiosConfig.data = data;
      try {
        const response = await axios.delete(actionLink, $_axiosConfig);
        data.id = response.data.id;
        commit("SET_FORMAT", data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_FORMATS(state, value) {
      state.$_formats = value;
    },
    SET_FORMAT(state, value) {
      state.$_currentFormat = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    },
    SET_DATAMAPS(state, value) {
      state.$_dataMaps = value;
    }
  }
};

export default FormatsVuexModule;
